import { employeeGetDescription as description } from './description';
import { get as execute } from './execute';

export { description, execute };
